import React, { useEffect, useState } from 'react';

import PaginationButton from 'Components/organisms/PaginationButton';
import classNames from 'classnames/bind';
import styles from './styles.module.scss';

const cx = classNames.bind(styles);
function PaginationComponent() {
  const [list, setList] = useState([
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
  ]);
  const [alreadyWriteNum, setAlreadyWriteNum] = useState(5);
  const [alreadyListMinNum, setAlreadyListMinNum] = useState(1);
  const [alreadyListMaxNum, setAlreadyListMaxNum] = useState(5);
  return (
    <div className={cx('pagination-container')}>
      {list?.slice(alreadyWriteNum - 5, alreadyWriteNum)?.map((e, idx) => {
        return <div className={cx('list-content')}>{e}번째 컨텐츠</div>;
      })}
      <PaginationButton
        item={5}
        maxCount={Math.ceil(list?.length / 5)}
        onChange={(e, min, max) => {
          setAlreadyWriteNum(e);
          setAlreadyListMinNum(min);
          setAlreadyListMaxNum(max);
        }}
        currentCount={alreadyWriteNum / 5}
        listMinPage={alreadyListMinNum}
        listMaxPage={
          alreadyListMaxNum >= Math.ceil(list?.length / 5)
            ? Math.ceil(list?.length / 5)
            : alreadyListMaxNum
        }
      />
    </div>
  );
}

export default PaginationComponent;

export const path = '/pagination';
